// extracted by mini-css-extract-plugin
export default {"appContent":"src-views-application-customer-routes-module__appContent"};